import { Route, Routes } from "react-router-dom";
import ContractorUserCreateScreen from "screens/App/CRM/CanUsers/ContractorUser/ContractorUserCreateScreen";
import ContractorUserDetailScreen from "screens/App/CRM/CanUsers/ContractorUser/ContractorUserDetailScreen";
import ContractorUserEditScreen from "screens/App/CRM/CanUsers/ContractorUser/ContractorUserEditScreen";
import ContractorUserListScreen from "screens/App/CRM/CanUsers/ContractorUser/ContractorUserListScreen";

const ContractorUserRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<ContractorUserCreateScreen />} />
      <Route path="list" element={<ContractorUserListScreen />} />
      <Route path=":id/detail" element={<ContractorUserDetailScreen />} />
      <Route path=":id/edit" element={<ContractorUserEditScreen />} />
    </Routes>
  );
};

export default ContractorUserRouter;
